import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { PlannedCourse } from '../../../../../global/builders/planned_course_builder';
import { INVALID_ID } from '../../../../../global/constants/ap_id_constants';
import { APPlannedCourseServant } from '../../../../../global/servants/ap_planned_course_servant';
import { DEEMPHASIZE_DROP_AREA, EMPHASIZE_DROP_AREA } from '../../../../constants/event_names';

class MultipleDegreeMapSlotGroupComponentController {
  private groupExpanded: boolean = false;
  private isEditable: boolean | string;
  private isGroupExpanded: boolean = false;
  private groupIconAngle: string = '0';
  private dropGenericSlots = []; // SGD-10826
  constructor(private ngComponentCommunicatorService: CommunicatorService) {}
  $onChanges() {
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
  }
  toggleGroupExpandCollapse() {
    this.isGroupExpanded = !this.isGroupExpanded;
    this.groupIconAngle = this.isGroupExpanded ? '90' : '0';
  }
  dndData(data: any, type: string) {
    let courseId;
    let slotId = INVALID_ID;
    if (type === 'DEV_REQ_COURSE') {
      courseId = _4.get(data, 'id', INVALID_ID);
    } else {
      slotId = _4.get(data, 'id', INVALID_ID);
      courseId = _4.get(_4.first(_4.get(data, 'courses', [])), 'id', INVALID_ID);
    }
    const courseGroupId = _4.get(data, 'courseGroupId', INVALID_ID);
    return {
      slotId,
      courseId,
      courseGroupId,
      isFromTerm: false,
      slotType: type
    };
  }

  emphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(EMPHASIZE_DROP_AREA);
  }
  deEmphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(DEEMPHASIZE_DROP_AREA);
  }
}

class MultipleDegreeMapSlotGroupComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      slots: '=',
      isEditable: '<?'
    };
    this.controller = MultipleDegreeMapSlotGroupComponentController;
    this.templateUrl =
      'capability-ng-academic-planner/src/plan/components/degree_map/components/degree_map_slot_group_component/multiple_degree_map_slot_group_component.html';
  }
}
angular
  .module('capability-ng-academic-planner')
  .component('multipleDegreeMapSlotGroupComponent', new MultipleDegreeMapSlotGroupComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/degree_map/components/degree_map_slot_group_component/multiple_degree_map_slot_group_component.ts